/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_LocationInputs */

const en__field_location = /** @type {(inputs: _Field_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location`)
};

const de__field_location = /** @type {(inputs: _Field_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Örtlichkeit`)
};

/**
* | output |
* | --- |
* | "Location" |
*
* @param {_Field_LocationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_location = /** @type {((inputs?: _Field_LocationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_LocationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_location(inputs)
	return de__field_location(inputs)
});